export default __webpack_public_path__ + "static/media/TasksBg.17c817ca.png";